define('modules/integrations/services/api/collection',['require','exports','module','app','env','base/collection'],function(require, exports, module) {
    'use strict';

    var app = require('app');
    var Config = require('env');
    var BaseCollection = require('base/collection');

    var Collection = BaseCollection.extend({
        initialize: function() {
            this.initRequestEvents();
        },
        url: function() {
            return Config.backendUrl + '/accounts/api-keys';
        },
        parse: function(response, options) {
            var apiKeys = response._embedded.api_keys;
            return apiKeys;
        }
    });

    module.exports = Collection;
});

